"use strict";
exports.__esModule = true;
exports.isNotParticipantSubAccount = exports.isParticipantSubAccount = exports.isNotOperationalSubAccount = exports.isOperationalSubAccount = exports.HouseSubAccountType = exports.AllSubAccountTypeList = exports.SubAccountType = exports.ParticipantSubAccountTypeList = exports.ParticipantSubAccountType = exports.OperationalSubAccountTypeList = exports.OperationalSubAccountType = void 0;
var OperationalSubAccountType;
(function (OperationalSubAccountType) {
    OperationalSubAccountType["forfeiture"] = "forfeiture";
    OperationalSubAccountType["spendingBudget"] = "spendingBudget";
    OperationalSubAccountType["error"] = "error";
    OperationalSubAccountType["breakage"] = "breakage";
    OperationalSubAccountType["billing"] = "billing";
    OperationalSubAccountType["dividend"] = "dividend";
    OperationalSubAccountType["moneyOut"] = "moneyOut";
    OperationalSubAccountType["moneyIn"] = "moneyIn";
    OperationalSubAccountType["suspense"] = "suspense";
    OperationalSubAccountType["settlement"] = "settlement";
})(OperationalSubAccountType = exports.OperationalSubAccountType || (exports.OperationalSubAccountType = {}));
exports.OperationalSubAccountTypeList = Object.values(OperationalSubAccountType).map(function (o) { return o.toString(); });
var ParticipantSubAccountType;
(function (ParticipantSubAccountType) {
    ParticipantSubAccountType["participantStandard"] = "participantStandard";
    ParticipantSubAccountType["participantOutsideInvestment"] = "participantOutsideInvestment";
    ParticipantSubAccountType["participantCash"] = "participantCash";
})(ParticipantSubAccountType = exports.ParticipantSubAccountType || (exports.ParticipantSubAccountType = {}));
exports.ParticipantSubAccountTypeList = Object.values(ParticipantSubAccountType).map(function (o) { return o.toString(); });
var SubAccountType;
(function (SubAccountType) {
    SubAccountType["participantStandard"] = "participantStandard";
    SubAccountType["participantOutsideInvestment"] = "participantOutsideInvestment";
    SubAccountType["participantCash"] = "participantCash";
    SubAccountType["forfeiture"] = "forfeiture";
    SubAccountType["spendingBudget"] = "spendingBudget";
    SubAccountType["error"] = "error";
    SubAccountType["breakage"] = "breakage";
    SubAccountType["billing"] = "billing";
    SubAccountType["dividend"] = "dividend";
    SubAccountType["moneyOut"] = "moneyOut";
    SubAccountType["moneyIn"] = "moneyIn";
    SubAccountType["suspense"] = "suspense";
    SubAccountType["settlement"] = "settlement";
})(SubAccountType = exports.SubAccountType || (exports.SubAccountType = {}));
exports.AllSubAccountTypeList = [
    SubAccountType.participantStandard,
    SubAccountType.participantOutsideInvestment,
    SubAccountType.participantCash,
    SubAccountType.forfeiture,
    SubAccountType.spendingBudget,
    SubAccountType.error,
    SubAccountType.breakage,
    SubAccountType.billing,
    SubAccountType.dividend,
    SubAccountType.moneyOut,
    SubAccountType.moneyIn,
    SubAccountType.suspense,
    SubAccountType.settlement,
];
var HouseSubAccountType;
(function (HouseSubAccountType) {
    HouseSubAccountType["billing"] = "billing";
    HouseSubAccountType["error"] = "error";
    HouseSubAccountType["moneyIn"] = "moneyIn";
    HouseSubAccountType["IRAConduit"] = "IRAConduit";
})(HouseSubAccountType = exports.HouseSubAccountType || (exports.HouseSubAccountType = {}));
// some convenience routines
function isOperationalSubAccount(accountType) {
    return exports.OperationalSubAccountTypeList.includes(accountType);
}
exports.isOperationalSubAccount = isOperationalSubAccount;
function isNotOperationalSubAccount(accountType) {
    return !exports.OperationalSubAccountTypeList.includes(accountType);
}
exports.isNotOperationalSubAccount = isNotOperationalSubAccount;
function isParticipantSubAccount(accountType) {
    return exports.ParticipantSubAccountTypeList.includes(accountType);
}
exports.isParticipantSubAccount = isParticipantSubAccount;
function isNotParticipantSubAccount(accountType) {
    return !exports.ParticipantSubAccountTypeList.includes(accountType);
}
exports.isNotParticipantSubAccount = isNotParticipantSubAccount;
